import { render, staticRenderFns } from "./PaginaAsignacionAprobadoresRevisoresMunicipalidad.vue?vue&type=template&id=5592a6d1&lang=es"
import script from "./PaginaAsignacionAprobadoresRevisoresMunicipalidad.vue?vue&type=script&lang=js"
export * from "./PaginaAsignacionAprobadoresRevisoresMunicipalidad.vue?vue&type=script&lang=js"
import style0 from "./PaginaAsignacionAprobadoresRevisoresMunicipalidad.vue?vue&type=style&index=0&id=5592a6d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports